module.exports = __webpack_public_path__ + "fonts/69d9cc4.woff";